const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h400v280H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102 265c30.137-26.667 62.47-40 97-40s66.863 13.333 97 40",
  stroke: "#1e3f6b",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 17
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.75 52.75c24.75.5 44.5 19.75 44.25 43l-.25 38.25c-.5 23.25-21.25 41.75-46 41-24.25-.5-43.5-17.75-44.25-40 0-1.5.75-2.25 2.5-2.25l21.5-.25c1.75 0 2.5.75 2.75 2.5 1 7.5 8.75 13.25 18 13.5 10.25.25 18.75-6.5 19-15l.25-38.25c0-8.5-8-15.75-18.5-16-9.25-.25-17.5 5.25-19 13-.25 1.5-1 2.25-3 2.25L47.5 94C46 94 45 93 45 91.5l3-88.25c0-1.75.75-2.5 2.5-2.5h79.25c1.75 0 2.5.75 2.5 2.5v21.5c0 1.5-1 2.5-2.5 2.5H76c-1.75 0-2.5.75-2.5 2.5l-.75 26.5c5.75-2.25 12.25-3.75 19-3.5zM201 175c-25 0-45.75-20.25-45.75-45.25v-84.5C155.25 20.25 176 0 201 0s45.75 20.25 45.75 45.25v84.5c0 25-20.75 45.25-45.75 45.25zm0-148.5c-10.25 0-19.25 8.5-19.25 18.75v84.5c0 10.25 9 18.75 19.25 18.75s19.25-8.5 19.25-18.75v-84.5c0-10.25-9-18.75-19.25-18.75zM314 175c-25 0-45.75-20.25-45.75-45.25v-84.5C268.25 20.25 289 0 314 0s45.75 20.25 45.75 45.25v84.5c0 25-20.75 45.25-45.75 45.25zm0-148.5c-10.25 0-19.25 8.5-19.25 18.75v84.5c0 10.25 9 18.75 19.25 18.75s19.25-8.5 19.25-18.75v-84.5c0-10.25-9-18.75-19.25-18.75zM285.902 203.887c-.935-9.901-6.553-16.813-10.7-29.108-.01-.027-.02-.053-.028-.08-.368-1-1.202-1.699-2.174-1.699-.974 0-1.808.7-2.176 1.702l-.026.074c-4.146 12.296-9.766 19.209-10.7 29.11C259.129 214.168 265.487 221 273 221c7.513 0 13.872-6.833 12.902-17.113",
  fill: "#1e3f6b"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#1e3f6b",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("path", {
  d: "M308.219 85.219l13.59 13.59M308 99.094L321.379 85"
})));

const Svg500 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 280,
    width: 400,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg500, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/500.dc50e599.svg";
export { ForwardRef as ReactComponent };